import { render, staticRenderFns } from "./PgaOfferEvaluationTotalCostsPresaleCreate.vue?vue&type=template&id=5424dc22&"
import script from "./PgaOfferEvaluationTotalCostsPresaleCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationTotalCostsPresaleCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5424dc22')) {
      api.createRecord('5424dc22', component.options)
    } else {
      api.reload('5424dc22', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationTotalCostsPresaleCreate.vue?vue&type=template&id=5424dc22&", function () {
      api.rerender('5424dc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/create/sub-components/PgaOfferEvaluationTotalCostsPresaleCreate.vue"
export default component.exports